import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { OccupancyType } from 'constants/loanApplication';

import { selectLoanApplication } from './loanApplication.selectors';

export const selectLoanApplicationProperties = createSelector(
  selectLoanApplication,
  ({ loanApplicationProperties }) => loanApplicationProperties ?? [],
);

export const selectLoanApplicationSubjectProperty = createSelector(
  selectLoanApplicationProperties,
  properties => properties.find(({ type }) => type === 'SubjectPropertyModel'),
);

export const selectLoanApplicationSubjectPropertyOccupancy = createSelector(
  selectLoanApplicationSubjectProperty,
  (subjectProperty = {}) => subjectProperty.occupancy?.type,
);

export const selectIsSubjectPropertyPrimaryResidence = createSelector(
  selectLoanApplicationSubjectPropertyOccupancy,
  occupancy => occupancy === OccupancyType.PRIMARY_RESIDENCE,
);

export const selectLoanApplicationSubjectPropertyState = createSelector(
  selectLoanApplicationSubjectProperty,
  (subjectProperty = {}) => subjectProperty.address?.address?.country?.state?.abbreviation,
);

export const selectLoanApplicationPropertiesByLiabilityId = memoizeOne(liabilityId =>
  createSelector(selectLoanApplicationProperties, properties =>
    properties.reduce((acc, { mortgages, id, address, type, status }) => {
      const { firstMortgageId, secondMortgageId } = mortgages;

      const {
        street,
        country: { state, zip },
        city,
        unit,
      } = address.address;

      const fullAddress = [street, city, unit, state?.abbreviation, zip].reduce(
        (acc, cur) => (acc += cur ? ` ${cur}` : ''),
        '',
      );

      const isLinkedLiability =
        !!liabilityId && [firstMortgageId, secondMortgageId].includes(liabilityId);
      const isPropertySelectionAllowed = !firstMortgageId || !secondMortgageId || isLinkedLiability;

      if (isPropertySelectionAllowed) {
        acc.push({
          name: fullAddress,
          value: id,
          isSubjectProperty: type === 'SubjectPropertyModel',
          propertyStatus: status,
        });
      }

      return acc;
    }, []),
  ),
);
